import exemplarRawData from './exemplar-raw-data'

const [headings, ...dataRows] = exemplarRawData

export interface Annotation {
  id: string
  tagId: string
  ranges: {
    index: number
    length: number
  }[]
  text: string
}

export interface ExemplarData {
  ID: string
  Category: string
  Exemplar_Statement: string
}

export const EXEMPLAR_DATA = Array.isArray(headings)
  ? dataRows.map((d) => {
      const exemplar = {} as ExemplarData
      for (const [i, h] of headings.entries()) {
        Object.assign(exemplar, { [h]: d[i] })
      }
      return exemplar
    })
  : []

export const EXEMPLAR = {
  ANNOTATION_STYLES: {
    MAX_PER_EXEMPLAR: 7,
    // Raw hex values used wherever a CSS color value is needed directly (e.g. inline styles).
    // Keep these in sync with BG_COLORS/BORDER_COLORS/TEXT_COLORS below.
    HEX_COLORS: ['#1a70bc', '#b343b6', '#448118', '#be4f23', '#6600ff', '#ffc000', '#d37c7e'],
    BG_COLORS: [
      'bg-[#1a70bc]',
      'bg-[#b343b6]',
      'bg-[#448118]',
      'bg-[#be4f23]',
      'bg-[#6600ff]',
      'bg-[#ffc000]',
      'bg-[#d37c7e]',
    ],
    BORDER_COLORS: [
      'border-[#1a70bc]',
      'border-[#b343b6]',
      'border-[#448118]',
      'border-[#be4f23]',
      'border-[#6600ff]',
      'border-[#ffc000]',
      'border-[#d37c7e]',
    ],
    TEXT_COLORS: [
      'text-[#1a70bc]',
      'text-[#b343b6]',
      'text-[#448118]',
      'text-[#be4f23]',
      'text-[#6600ff]',
      'text-[#ffc000]',
      'text-[#d37c7e]',
    ],
  },
}
